<div class="player" [ngClass]="{ 'player--vimeo': true, 'player-error': playerState() === 'Error' }">
    @if (!loadIFrame || !showVideoFrame) {
        <div class="thumbnail-wrapper">

            @if (showConsentDisclaimer) {
                <button
                    class="consent-disclaimer"
                    (click)="cookieConsentService.openCookieConsentPopup()"
                >
                    <span>
                        {{
                            'cookieConsent.youtube'
                                | translate
                                | formatString: { category: ('cookieConsent.statistic' | translate) }
                        }}
                        <br />
                        {{ 'cookieConsent.changeConsent' | translate }}
                    </span>
                </button>
            } @else {
                @if (!autoplay) {
                    <button class="play-button kk-link-cover" type="button" (click)="loadVideoFrame(true)">
                        <span class="kk-visuallyhidden">{{ 'general.action.play' | translateSafe }}</span>
                        <app-svg-icon iconName="play" class="play-icon"></app-svg-icon>
                    </button>
                }
            }

            @if (playerState() === 'Idle') {
                @if ((thumbnail | getVideoThumbnail: videoId) | async; as thumbnailUrl) {
                    @defer (on immediate) {
                        <img
                            [ngSrc]="thumbnailUrl"
                            [alt]="caption | safe: 'html'"
                            class="thumbnail"
                            width="1400"
                            height="787"
                        />
                    } @placeholder {
                        <div class="placeholder">
                            <app-loading-dots></app-loading-dots>
                        </div>
                    }
                }
            }
        </div>

        @if (playerState() === 'Error') {
            <p class="player-error-message" [innerHTML]="videoError"></p>
        }
    }

    <div class="video-player">
        <div #vimeoPlayer></div>
    </div>
</div>

@if (caption) {
    <span class="caption" [innerHTML]="caption | safe:'html' "></span>
}
